// **********************************************************
// Card Slider
// **********************************************************

const cardSlider = document.querySelectorAll('[data-slider="card-slider"]');

const cardSliderOptions = {
  slidesPerView: 1.1,
  spaceBetween: 15,
  speed: 800,
  watchOverflow: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'fraction',
    clickable: true,
    renderFraction(currentClass, totalClass) {
      return `<span class="${currentClass}"></span><span> / </span><span class="${totalClass}"></span><span></span>`;
    },
  },
  breakpoints: {
    767: {
      slidesPerView: 1.5,
      spaceBetween: 20,
    },
    1023: {
      slidesPerView: 2.2,
      spaceBetween: 20,
    },
    1199: {
      slidesPerView: 2.2,
      spaceBetween: 30,
    },
    1441: {
      slidesPerView: 'auto',
      spaceBetween: 40,
    },
  },
};

cardSlider.forEach((el) => {
  const cardSlider = el.closest('.card-slider');
  const paginationElement = cardSlider.querySelector('.swiper-pagination');

  if (cardSlider.classList.contains('card-slider--secondary')) {
    cardSliderOptions.pagination.type = windowWidth() > breakpointMd ? 'fraction' : 'bullets';
    cardSliderOptions.slidesPerView = windowWidth() < breakpointSm && '1';
    cardSliderOptions.spaceBetween = windowWidth() < breakpointSm && '8';
  }

  const arrowRight = cardSlider.querySelector('.arrow-right');
  const arrowLeft = cardSlider.querySelector('.arrow-left');
  cardSliderOptions.pagination.el = paginationElement;

  cardSliderOptions.navigation.nextEl = arrowRight;
  cardSliderOptions.navigation.prevEl = arrowLeft;

  new Swiper(el, cardSliderOptions);
});
